import { useRef, useState } from 'react';
import Icon from 'components/Icon';

export default function FileUpload({ accept, multiple, onFileChange, label, hint }) {
  const [drag, setDrag] = useState(false);
  const [names, setNames] = useState([]);
  const ref = useRef();

  const handle = (files) => {
    const arr = Array.from(files);
    setNames(arr.map(f => f.name));
    onFileChange(multiple ? arr : arr[0]);
  };

  return (
    <div
      className={`upload-area ${drag ? 'drag' : ''}`}
      onDragOver={e => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={e => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files); }}
      onClick={() => ref.current.click()}
    >
      <input ref={ref} type="file" accept={accept} multiple={multiple}
        onChange={e => handle(e.target.files)} onClick={e => e.stopPropagation()} />
      <div className="upload-u-icon"><Icon name="upload" size={22} /></div>
      <h3>{label || 'Click or drag & drop your file here'}</h3>
      <p>{hint || `Supported: ${accept || 'any file'}`}</p>
      {names.length > 0 && (
        <div className="upload-file-tag">
          <Icon name="check" size={13} />
          {names.length === 1 ? names[0] : `${names.length} files selected`}
        </div>
      )}
    </div>
  );
}
